<script>
  import commonPictureConfig from './commonPictureConfig'

  export default {
    mixins: [commonPictureConfig],
    props: {
      cloudinaryBaseUrl: {
        type: String,
        default: ""
      }
    },
    methods: {
      getCloudinaryUrl (img, dimension) {
        // Memory leak fix. When calling this.$root.envConfig.cloudinaryBaseUrl from the server (SSR) for some reason a huge memory leak occurs.
        // To prevent this we need to send the url as a prop (in pageSchema primarely, probably only there the call is done on the server).
        // We keep the $root-url as a backup for all client side calls
        const _cloudinaryBaseUrl = this.cloudinaryBaseUrl || this.$root.envConfig.cloudinaryBaseUrl

        if (!img || (this.dynamicDimensions && !this.hasMounted)) {
          return
        }

        const { w, h, x, y } = this.getDimensions(img),
          filename = encodeURIComponent(img.filename.trim())
        let scaleParams = ''

        if (dimension.height) {
          let type = this.fitDimensions ? 'c_fit' : 'c_lfill'
          scaleParams = `/w_${dimension.width},h_${dimension.height},${type}`
        } else if (dimension.width < w) {
          scaleParams = `/w_${dimension.width},h_${Math.round((dimension.width * h) / w)},c_scale`
        }
        if ((img && img.provider) && (img.provider.toLowerCase() == 'epi%20assets')) {
          return `${_cloudinaryBaseUrl}/image/upload/w_${w},h_${h},x_${x},y_${y},c_crop${scaleParams}${this.sharpenParam}/f_auto,${this.qualityParam},${this.dprParam}/cumulus/${img.provider}/${img.id}/${filename}`
        }
        if ((img && img.catalog) && img.catalog.toLowerCase() === 'epi%20assets') {
          return `${_cloudinaryBaseUrl}/image/upload/w_${w},h_${h},x_${x},y_${y},c_crop${scaleParams}${this.sharpenParam}/f_auto,${this.qualityParam},${this.dprParam}/cumulus/${img.catalog}/${img.id}/${filename}`
        } else {
          return `${_cloudinaryBaseUrl}/w_${w},h_${h},x_${x},y_${y},c_crop${scaleParams}${
            this.sharpenParam
          }/f_auto,${this.qualityParam},${this.dprParam}/${filename}`
        }
      }
    }
  }
</script>
